import {connect} from 'react-redux';

import {
  buildContactsManagerAutoContactsUrl,
  buildContactsManagerPrivateContactsUrl,
  buildContactsManagerSharedContactsUrl,
  contactsManagerAccountsUrl,
  makeContactsManagerCardGroupsUrl,
} from '../../../../../../../src/helpers/contactsManagerHelpers';
import {ThunkAction} from '../../../../../../../src/store/appThunk';
import {
  getAllRunningSyncAccountsJobs,
  getAllRunningSyncCardsJobs,
} from '../../../../../../../src/store/data/jobs/jobsSelectors';
import {updateSizeAction} from '../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getSizes} from '../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {getUserNamespace} from '../../../../../../../src/store/data/teammates/teammatesSelectors';
import {makeGetCurrentRouteType} from '../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {ContactsManagerParametersTypesEnum} from '../../../../../../../src/store/panels/contacts/contactsManager/parameters/contactsManagerParameters';
import {navigateToLinkAction} from '../../../../../../../src/store/stateless/navigationActions';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {ContactsManagerNavigation} from './contactsManagerNavigation';

/*
 * Selectors.
 */

const getIsAccountSyncRunning = createSelector([getAllRunningSyncAccountsJobs], (jobs) => jobs.length > 0);

const getIsCardSyncRunning = createSelector([getAllRunningSyncCardsJobs], (jobs) => jobs.length > 0);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  sizes: getSizes,
  currentRouteType: makeGetCurrentRouteType(),
  isAccountSyncRunning: getIsAccountSyncRunning,
  isCardSyncRunning: getIsCardSyncRunning,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateSize: updateSizeAction,
  onNavigate:
    (routeType: ContactsManagerParametersTypesEnum): ThunkAction =>
    (dispatch, getState) => {
      switch (routeType) {
        case ContactsManagerParametersTypesEnum.ACCOUNTS:
          dispatch(navigateToLinkAction(contactsManagerAccountsUrl));
          break;

        case ContactsManagerParametersTypesEnum.SHARED_CONTACTS:
          dispatch(navigateToLinkAction(buildContactsManagerSharedContactsUrl()));
          break;

        case ContactsManagerParametersTypesEnum.PRIVATE_CONTACTS:
          dispatch(
            navigateToLinkAction(buildContactsManagerPrivateContactsUrl(getUserNamespace(getState()))),
          );
          break;

        case ContactsManagerParametersTypesEnum.AUTO_CONTACTS:
          dispatch(navigateToLinkAction(buildContactsManagerAutoContactsUrl()));
          break;
        case ContactsManagerParametersTypesEnum.LISTS:
          dispatch(navigateToLinkAction(makeContactsManagerCardGroupsUrl()));
          break;

        // Default back to the shared contacts page
        default:
          dispatch(navigateToLinkAction(buildContactsManagerSharedContactsUrl()));
      }
    },
}));

export const ContactsManagerNavigationContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsManagerNavigation);
